var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Content",
    { attrs: { id: "users" } },
    [
      _c(
        "div",
        { attrs: { slot: "search" }, slot: "search" },
        [
          _c(
            "Form",
            { attrs: { "label-width": 50, model: _vm.search } },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "文件名", "label-width": 65 } },
                        [
                          _c("Input", {
                            model: {
                              value: _vm.search.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "name", $$v)
                              },
                              expression: "search.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "状态" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.search.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "status", $$v)
                                },
                                expression: "search.status",
                              },
                            },
                            _vm._l(_vm.statusList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  staticStyle: { width: "100%" },
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "日期" } },
                        [
                          _c("DatePicker", {
                            staticStyle: { width: "114px" },
                            attrs: {
                              type: "date",
                              editable: false,
                              placeholder: "开始日期",
                              format: "yyyy-MM-dd",
                            },
                            on: { "on-change": _vm.changestart },
                            model: {
                              value: _vm.search.startDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "startDate", $$v)
                              },
                              expression: "search.startDate",
                            },
                          }),
                          _c("DatePicker", {
                            staticStyle: { width: "114px" },
                            attrs: {
                              type: "date",
                              editable: false,
                              placeholder: "结束日期",
                              format: "yyyy-MM-dd",
                            },
                            on: { "on-change": _vm.changeend },
                            model: {
                              value: _vm.search.endDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "endDate", $$v)
                              },
                              expression: "search.endDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("Col", [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _vm._v("  "),
                        _c(
                          "Button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.query },
                          },
                          [_vm._v("查询")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "singleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.dataList,
            "header-cell-style": {
              background: "#f8f8f9",
              color: "#515a6e",
              "text-align": "center",
            },
            "row-class-name": _vm.tableRowClassName,
            "highlight-current-row": "",
            "highlight-selection-row": "",
            "row-key": "id",
            "max-height": _vm.tableHeight,
          },
          on: { "row-click": _vm.selectrow },
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "left",
              align: "center",
              prop: "taskName",
              label: "体检任务",
              "show-overflow-tooltip": "",
              "min-width": "150",
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "left",
              align: "center",
              prop: "schoolName",
              label: "学校名称",
              "show-overflow-tooltip": "",
              "min-width": "150",
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "left",
              align: "center",
              prop: "fileName",
              label: "文件名",
              "show-overflow-tooltip": "",
              "min-width": "300",
            },
            scopedSlots: _vm._u([
              {
                key: "fileName",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          row.fileName
                            ? row.fileName.replace(
                                row.fileName.substring(
                                  row.fileName.lastIndexOf("_"),
                                  row.fileName.lastIndexOf(".")
                                ),
                                ""
                              )
                            : ""
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "type",
              label: "类型",
              "min-width": "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm.typesList.filter((u) => u.value === row.type)[0]
                          .label
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "times",
              label: "用时(s)",
              "min-width": "50",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "total",
              label: "总数",
              "min-width": "50",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "completeNum",
              label: "完成数量",
              "min-width": "80",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "createTime",
              label: "操作时间",
              "min-width": "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "status",
              label: "状态",
              "min-width": "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.status
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "small",
                              type:
                                row.status === 3
                                  ? "success"
                                  : row.status === 2 || row.status === 6
                                  ? "warning"
                                  : row.status === 1
                                  ? "primary"
                                  : row.status === 4 || row.status === 7
                                  ? "danger"
                                  : "info",
                              "disable-transitions": "",
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.statusList.filter(
                                    (u) => u.value === row.status
                                  )[0].label
                                ) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              align: "center",
              prop: "operation",
              label: "操作",
              "min-width": "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          size: "medium",
                          disabled: !(row.status === 2 || row.status === 3),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.downloadFile(row)
                          },
                        },
                      },
                      [_vm._v("文件下载")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("Page", {
        staticStyle: { "margin-top": "10px" },
        attrs: {
          total: _vm.pageList.total,
          current: _vm.pageList.currentPage,
          "page-size": _vm.pageList.pageSize,
          "show-elevator": "",
          "show-sizer": "",
          "show-total": "",
          "page-size-opts": [10, 20, 40, 80],
        },
        on: {
          "on-change": _vm.chagecurrent,
          "on-page-size-change": _vm.chagepagesize,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }